import { UserRole } from '../OrgUnitAssortmentDTO';

export const Resources = [
  'DASHBOARD',
  'ASSORTMENT',
  'ASSORTMENT_ITEMS',
  'MONITORING_ASSORTMENT_ITEMS',
  'PRICE_CALCULATION',
  'PRICE_CALCULATION__ITEM_PRICES',
  'PRICE_CALCULATION__PURCHASE_CONDITION',
  'PRICE_CALCULATION__FREIGHT',
  'PRICE_CALCULATION__MARKUP',
  'PRICE_CALCULATION__PRICE_SUGGESTIONS',
  'PRICE_CALCULATION__ROUNDING',
  'PRICE_SUGGESTIONS',
  'PRICE_CALCULATION__SALES_PRICE_CONDITION',
  'PRICE_CALCULATION__CUSTOMER_MARKUP',
  'PRICE_CALCULATION__COMBINED',
  'DISCOUNT_CUSTOMERS',
  'ITEM_SEARCH',
  'SYNC_SFTP',
  'MARKET_INSIGHT',
  'ADMINISTRATION',
  'PURCHASE_PRICES',
  'ROUNDING',
  'ITEM_EXPORT',
  'FEATURE_TOGGLES',
  'PERMISSIONS',
  'APPROVAL',
  'PRICE_CONTROL',
  'CAMPAIGN',
  'MEMBER_CAMPAIGN',
  'LOCAL_CAMPAIGN',
  'CENTRAL_ASSORTMENT',
  'CENTRAL_ASSORTMENT_MEMBER_VIEW',
  'SUB_ASSORTMENTS',
  'SUPPLIER_ITEMS_INSIGHT_REPORT',
  'EXTENDED_MG_ITEM_INFO',
  'MEMBER_CONFIG',
] as const;
export type Resource = (typeof Resources)[number];

export const orgTypes = [
  'RETAIL_BRAND',
  'RETAIL_LOCATION',
  'RETAIL_DATAOWNER',
  'WHOLESALE_LOCATION',
  'RETAIL_LOCATION_LIGHT',
  'RETAIL_LOCATION_LIGHT_PLUS',
  'RETAIL_LOCATION_UNDER_MASTER',
  'WHOLESALE_PRICE_LIST',
  'WHOLESALE_BRAND',
] as const;
export type OrgType = (typeof orgTypes)[number];

export type Action = 'CREATE' | 'READ' | 'UPDATE' | 'DELETE';

export type AppTenantCountryCode = 'NO' | 'SE';

export type UserPermissionRole = UserRole | 'SUPERUSER';

interface PermissionProps {
  resource: Resource;
  actions: Action[];
  userRole: UserPermissionRole;
  orgType: OrgType;
  appTenants: AppTenantCountryCode[];
}

export class Permission {
  readonly resource: Resource;
  readonly actions: Action[];
  readonly userRole: UserPermissionRole;
  readonly orgType: OrgType;
  readonly appTenants: AppTenantCountryCode[];

  constructor({ resource, actions, userRole, orgType, appTenants }: PermissionProps) {
    this.resource = resource;
    this.actions = actions;
    this.userRole = userRole;
    this.orgType = orgType;
    this.appTenants = appTenants;
  }

  static noActions(props: Omit<PermissionProps, 'actions'>): Permission {
    return new Permission({
      ...props,
      actions: [],
    });
  }

  canRead(): boolean {
    return this.actions.includes('READ');
  }

  canDelete(): boolean {
    return this.actions.includes('DELETE');
  }

  canCreate(): boolean {
    return this.actions.includes('CREATE');
  }

  canUpdate(): boolean {
    return this.actions.includes('UPDATE');
  }
}
